import React, { useEffect, useRef, useState } from "react";
import { Search, X, Home, Users } from "lucide-react";
import { api } from "../../lib/api";
import { C, FONT } from "./ui";
import { Sheet, Empty } from "./Sheet";

// Sheet Cari nama warga: nama / @username warga terverifikasi kota ini (tanpa kata kunci → warga terbaru).
// Ketuk hasil → kunjungi rumah warga itu.
export function SearchSheet({ nB, nR, cityId, onWarga, onClose }) {
  const [q, setQ] = useState("");
  const [hasil, setHasil] = useState(null);
  const inputRef = useRef(null);
  useEffect(() => { const t = setTimeout(() => inputRef.current?.focus(), 350); return () => clearTimeout(t); }, []);

  // debounce 250 ms saat mengetik
  useEffect(() => {
    const s = q.trim();
    const t = setTimeout(() => {
      api.rumahCari(s, cityId).then(r => setHasil(r.hasil || [])).catch(() => setHasil([]));
    }, s ? 250 : 0);
    return () => clearTimeout(t);
  }, [q, cityId]);

  const daftar = hasil || [];
  return (
    <Sheet testid="search-sheet" title="Cari nama warga" icon={Search} onClose={onClose} tall={false}
      sub={<span data-testid="search-status"><b style={{ color: C.ink }}>{nB}</b> bangunan · <b style={{ color: C.ink }}>{nR}</b> jalan</span>}>
      <div style={{ display: "flex", alignItems: "center", gap: 8, height: 46, padding: "0 10px 0 14px", background: C.cream, borderRadius: 99, marginBottom: 10 }}>
        <Search size={16} color={C.sub} />
        <input ref={inputRef} data-testid="search-input" value={q} onChange={e => setQ(e.target.value)} enterKeyHint="search"
          placeholder="Nama atau @username warga..."
          style={{ flex: 1, minWidth: 0, border: 0, outline: "none", background: "transparent", fontSize: 15, fontFamily: FONT, color: C.ink, fontWeight: 600 }} />
        {q && (
          <button data-testid="search-clear" aria-label="Hapus pencarian" onClick={() => { setQ(""); inputRef.current?.focus(); }}
            style={{ width: 28, height: 28, borderRadius: 99, border: 0, background: "#fff", display: "grid", placeItems: "center", cursor: "pointer", color: C.ink }}>
            <X size={14} />
          </button>
        )}
      </div>
      <div data-testid="search-warga-results">
        {!q.trim() && daftar.length > 0 && <p style={{ margin: "0 4px 6px", fontSize: 11.5, fontWeight: 700, letterSpacing: .4, color: C.sub, textTransform: "uppercase" }}>Warga terbaru</p>}
        {hasil && daftar.length === 0 && (
          q.trim() ? <p data-testid="search-warga-empty" style={{ margin: 0, padding: "12px 4px", fontSize: 13, color: C.sub }}>Tidak ada warga bernama “{q.trim()}” di kota ini.</p>
            : <Empty icon={Users} text="Belum ada warga terverifikasi di kota ini." />
        )}
        {daftar.map(w => (
          <button key={w.id} data-testid={`search-warga-${w.ig_username}`} onClick={() => { onWarga(w); onClose(); }}
            style={{ width: "100%", display: "flex", alignItems: "center", gap: 12, padding: "10px 6px", background: "transparent", border: 0, borderRadius: 14, cursor: "pointer", textAlign: "left", fontFamily: FONT, color: C.ink }}>
            <span style={{ width: 38, height: 38, borderRadius: 99, background: C.cream, display: "grid", placeItems: "center", flex: "none", fontWeight: 800, color: C.blue, fontSize: 15 }}>{(w.nama || w.ig_username || "?").trim()[0].toUpperCase()}</span>
            <span style={{ flex: 1, minWidth: 0 }}>
              <span style={{ display: "block", fontSize: 14.5, fontWeight: 700, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{w.nama || w.ig_username}</span>
              <span style={{ display: "block", fontSize: 12, color: C.sub }}>@{w.ig_username}{w.profesi_utama ? ` · ${w.profesi_utama} Lv ${w.level || 1}` : ""}{w.suka ? ` · ${w.suka} suka` : ""}</span>
            </span>
            <span style={{ display: "inline-flex", alignItems: "center", gap: 5, fontSize: 12, fontWeight: 700, color: C.blue, flex: "none" }}><Home size={14} /> Rumah</span>
          </button>
        ))}
      </div>
    </Sheet>
  );
}
